module.exports = __webpack_public_path__ + "static/promo-b55e8499356de563ff038dc046a55f7e.png";